var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueAlerts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "notifications",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 100,
    height: 100
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#0072F5",
    d: "M72.3946,46.6317v16.022 c0,3.63,2.812,7.222,5.589,8.895c0.719,0.433,1.148,1.192,1.148,2.03c0,1.306-1.062,2.369-2.369,2.369h-43.526v-29.316 c0-11.3203,8.5806-20.6748,19.5792-21.9008C63.8141,25.957,72.3946,35.3114,72.3946,46.6317z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M50.3586,24.5947h-1.085 c-12.151,0-22.037,9.886-22.037,22.037v16.022c0,3.63-2.812,7.222-5.588,8.895c-0.72,0.433-1.148,1.192-1.148,2.03 c0,1.306,1.062,2.369,2.368,2.369h53.894c1.307,0,2.369-1.063,2.369-2.369c0-0.838-0.429-1.597-1.148-2.03 c-2.777-1.673-5.589-5.265-5.589-8.895v-16.022C72.3946,34.4807,62.5086,24.5947,50.3586,24.5947z M49.8156,18.0004 c2.791,0,5.053,2.261,5.053,5.052c0,0.3321-0.0407,0.6525-0.1089,0.9633c10.6169,2.0521,18.6349,11.3976,18.6349,22.616v16.022 c0,3.101,2.447,6.438,5.105,8.038c0.977,0.589,1.632,1.662,1.632,2.887c0,1.861-1.508,3.369-3.369,3.369l-20.452,0.0004 c-0.7476,2.9026-3.3587,5.0517-6.4946,5.0517c-3.1358,0-5.747-2.1491-6.4946-5.0517l-20.4528-0.0004 c-1.861,0-3.368-1.508-3.368-3.369c0-1.225,0.654-2.298,1.631-2.887c2.659-1.6,5.105-4.937,5.105-8.038v-16.022 c0-11.218,8.0183-20.5633,18.6363-22.6171c-0.0696-0.3096-0.1103-0.6301-0.1103-0.9622 C44.7626,20.2614,47.0256,18.0004,49.8156,18.0004z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueAlerts);
export default __webpack_public_path__ + "static/media/blueAlerts.658d354e.svg";
export { ForwardRef as ReactComponent };